import React from "react";

interface TooltipProps {
  text: string;
  children: React.ReactNode;
  position?: "top" | "bottom" | "left" | "right";
  condition?: boolean;
  arrowClassName?: string;
}

const Tooltip: React.FC<TooltipProps> = (
  {
    text,
    children,
    position = "top",
    condition = true,
    arrowClassName,
  }: TooltipProps) => {

  const tooltipPositionClasses = {
    top: "left-1/2 -translate-x-1/2 -top-7",
    bottom: "left-1/2 -translate-x-1/2 top-full",
    left: "-left-7 top-1/2 -translate-y-1/2",
    right: "left-full top-1/2 -translate-y-1/2",
  }

  return (
    <div className="relative group">
      {children}
      {condition && (
        <div
          className="absolute z-50 left-1/2 -translate-x-1/2 -top-7 bg-n-400 text-xs text-n-200 px-3 py-1 rounded-md shadow-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap"
        >
          {text}
          <div
            className={`absolute left-1/2 -translate-x-1/2 top-full w-2 h-2  ${tooltipPositionClasses[position]} ${arrowClassName}`}></div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;